import { render, staticRenderFns } from "./df-news-card.vue?vue&type=template&id=02e55c13&"
import script from "./df-news-card.ts?vue&type=script&lang=js&"
export * from "./df-news-card.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports